// DateHelper
export default
{
	getDate(dateString)
	{
		if (!dateString)
		{
			return null;
		}

		const datePart = String(dateString).split("T")[0];
		const [year, month, day] = datePart.split(/[/-]/).map(part => parseInt(part, 10));
		const normalizedDate = new Date(Date.UTC(year, month - 1, day));
		return isNaN(normalizedDate.getTime()) ? null : normalizedDate;
	},

	toISOString(dateString)
	{
		const normalizedDate = this.getDate(dateString);
		return normalizedDate ? normalizedDate.toISOString() : null;
	},

	formatDate(dateString)
	{
		const normalizedDate = dateString instanceof Date ? dateString : this.getDate(dateString);
		if (!normalizedDate)
		{
			return "";
		}

		return `${normalizedDate.getUTCMonth() + 1}/${normalizedDate.getUTCDate()}/${normalizedDate.getUTCFullYear()}`;
	},

	getCurrentDate()
	{
		const today = new Date();
		return new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), 0, 0, 0, 0));
	},

	getDateTime(dateString)
	{
		const matchesExpectedUtcFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d+$/.test(dateString);
		return new Date(matchesExpectedUtcFormat ? dateString+"+00:00" : dateString);
	}
};



// WEBPACK FOOTER //
// ./Components/utils/DateHelper.jsx